import React from 'react'

import { PartialUser } from 'types/user'

import { SubscribedTrainersTab } from './SubscribedTrainersTab'

type FollowersMembersTabsProps = {
  trainer: PartialUser
}

export const FollowersMembersTabs = ({ trainer }: FollowersMembersTabsProps) => {
  return <SubscribedTrainersTab trainer={trainer} />
}
